import { useState, useEffect, useCallback } from 'react';
import FilterTags from '@creditflowresearch/uilib/FilterTags';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import { useColumnsCustomizationContext } from '@/creditflowresearch/application/BondScreener/Sidebar/useColumnsCustomizationContext';
import { buildColumnsTag, type ITagExtractorContext, type IFilterTag } from '@/creditflowresearch/ui/common/components/FilterTags';
import type { TFilterPayload } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilter';
import type { ICorporateBondScreenerFilterBoundaries } from '@/creditflowresearch/domain/vo/Bondscreener';
import useTagRemove from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Tags/useTagRemove';
import buildCorporateFilterTags from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Tags/buildCorporateFilterTags';

const CorporateBondScreenerSidebarTags = () => {
  const { getDraft, filters: boundaries, subscribe } = useCorporateBondScreenerSidebarFilterContext();
  const { draftColumns } = useColumnsCustomizationContext();
  const onTagRemove = useTagRemove();
  const [tags, setTags] = useState<IFilterTag[]>([]);

  const selectedColumnsCount = draftColumns.filter((col) => col.isVisible).length;

  const rebuildTags = useCallback((): void => {
    const ctx: ITagExtractorContext<TFilterPayload, ICorporateBondScreenerFilterBoundaries> = {
      filters: getDraft(),
      boundaries,
    };
    setTags(buildCorporateFilterTags(ctx));
  }, [getDraft, boundaries]);

  useEffect(() => {
    rebuildTags();
    return subscribe(rebuildTags);
  }, [rebuildTags, subscribe]);

  const allTags: IFilterTag[] = [...tags, buildColumnsTag(selectedColumnsCount)];

  return <FilterTags tags={ allTags } onTagRemove={ onTagRemove } dataTest="corporateBondScreenerTags" />;
};

export default CorporateBondScreenerSidebarTags;
